import PropTypes from 'prop-types';

const { string, shape, arrayOf } = PropTypes;
const categoryShape = {
  id: string.isRequired,
  name: string,
  semantic_id: string,
};

const categoryType = arrayOf(
  shape({
    children: arrayOf(shape(categoryShape)),
    ...categoryShape,
  })
);

export default categoryType;
